import React, { useEffect, useState } from "react";
import { IonAlert, IonIcon, IonPopover, IonToggle } from "@ionic/react";
import { chevronBack, informationCircleOutline } from "ionicons/icons";
import { useHistory, useLocation } from "react-router";
import classNames from "classnames/bind";
import { activeModule } from "../../providers/active-module";
import { setActiveModule } from "../../providers/active-module/activeModule";
import styles from "./toogleActivemodule.module.scss";
import { useAuth } from "../../contexts/auth-context";
import { useGetMeMutation } from "../../providers/profile";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

interface ToggleActiveModuleProps {
  className?: string;
  isViewDescription: boolean;
  isViewPopover?: boolean;
  containerClassName?: string;
  isFixedButtonWithAlert?: boolean;
}

const PRODUCT_PATHS = ["home3"];

const ToggleActiveModule = ({
  className,
  isViewDescription,
  isViewPopover,
  containerClassName,
  isFixedButtonWithAlert = false,
}: ToggleActiveModuleProps) => {
  const history = useHistory();
  const location = useLocation();
  const { isUserAuthenticated } = useAuth();
  const [showAlert, setShowAlert] = useState(false);
  const [showInfoPopover, setShowInfoPopover] = useState(false);
  const { t } = useTranslation();
  const { mutateAsync: getMeMutate } = useGetMeMutation();

  const toggleModule = async () => {
    const module = activeModule === "PARHATO2" ? "CORE" : "PARHATO2";
    setActiveModule({ current: module, isModuleInitialized: true });
    if (activeModule === "PARHATO2" && isUserAuthenticated) {
      await getMeMutate();
    }
    history.replace("/");
    window.location.reload();
  };

  const shouldHideButton = !PRODUCT_PATHS.some((path) => location.pathname.includes(path));

  const handleOpenAlert = () => {
    setShowAlert(true);
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  if (isFixedButtonWithAlert && shouldHideButton) {
    return null;
  }

  const description = activeModule === "PARHATO2" ? t("Old version description") : t("New version description");

  return (
    <>
      {isFixedButtonWithAlert ? (
        <div
          onClick={handleOpenAlert}
          className=" flex items-center justify-center w-[8.5rem] h-14 fixed bottom-[1.375rem] left-[1.5rem] rounded-3xl overflow-hidden z-[1000] bg-primary"
        >
          <IonIcon icon={chevronBack} className="text-sm font-bold" />
          <span className="text-sm font-bold">{t("Old version")}</span>
        </div>
      ) : (
        <div className={cx("flex items-center gap-2 pt-2.5", className)}>
          <div className="flex items-center justify-between w-full gap-2">
            {isViewDescription && <div className={cx("classText")}>{description}</div>}

            <div className={cx("flex items-center gap-2.5", containerClassName)}>
              {isViewPopover && (
                <div className="relative flex items-center">
                  <div onClick={() => setShowInfoPopover(true)} className="h-6">
                    <IonIcon
                      icon={informationCircleOutline}
                      color="medium"
                      className="cursor-pointer"
                      id="module-info-icon"
                    />
                  </div>
                  <IonPopover
                    isOpen={showInfoPopover}
                    onDidDismiss={() => setShowInfoPopover(false)}
                    trigger="module-info-icon"
                    side="bottom"
                    alignment="center"
                    arrow={true}
                    dismissOnSelect={true}
                    className="module-info-popover"
                  >
                    <div className="px-4 py-3 max-w-xs">
                      <ul className="text-xs text-gray-700">
                        <li className="mb-1">
                          <strong>({t("Old version")}):</strong> {t("Old version description")}
                        </li>
                      </ul>
                    </div>
                  </IonPopover>
                </div>
              )}
              <IonToggle checked={activeModule === "PARHATO2"} onIonChange={handleOpenAlert} color="success" />
            </div>
          </div>
        </div>
      )}

      <IonAlert
        isOpen={showAlert}
        onDidDismiss={handleCloseAlert}
        header={t("Confirm action")}
        message={
          activeModule === "PARHATO2"
            ? t("Click to switch to the old version")
            : t("Click to switch to the new version")
        }
        buttons={[
          {
            text: t("Cancel"),
            role: "cancel",
            cssClass: "!text-red-500",
          },
          {
            text: t("Confirm"),
            handler: () => {
              toggleModule();
              handleCloseAlert();
            },
            cssClass: "!text-green-500",
          },
        ]}
      />
    </>
  );
};

export default ToggleActiveModule;
